import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';
import { Box, Text } from 'grommet';

const InfringementsPerEventChart = ({
  data,
  primaryText = 'var(--page-primary-text)',
  subTitle = null,
  secondaryText = 'var(--page-secondary-text)',
  color = null,
  chartTooltip,
}) => (
  <Box direction="column" gap="1rem">
    <Box direction="column" gap="0.5rem">
      <Text color={primaryText} size="1rem" weight={700}>
        Infringements Per Event
      </Text>
      {subTitle && (
        <Text color={secondaryText} size="0.8rem" weight={400}>
          {subTitle}
        </Text>
      )}
    </Box>
    <Box height="19rem" width="100%">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E6EEF6" />
          <XAxis dataKey="eventName" tick={{ fill: '#5D738A', fontSize: 11 }} />
          <YAxis tick={{ fill: '#5D738A', fontSize: 11 }} />
          <Tooltip {...chartTooltip} formatter={(value) => value.toLocaleString()} />
          <Bar dataKey="infringements" fill={color || '#2563EB'} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  </Box>
);

InfringementsPerEventChart.propTypes = {
  data: PropTypes.array.isRequired,
  primaryText: PropTypes.string,
  color: PropTypes.string,
  chartTooltip: PropTypes.object.isRequired,
  subTitle: PropTypes.string,
  secondaryText: PropTypes.string,
};

export default InfringementsPerEventChart;
